import { connect } from 'react-redux';
import { get } from 'lodash';
import HeaderLogin from './header-login.component';
import { logOut, requestLoginSession } from 'modules/login/login.actions';
import { Dispatch } from 'types/dispatch';

const mapStateToProps = (state: Object) => ({
    config: get(state, 'config'),
    loginSession: get(state, 'login.loginSession'),
    hasTPCEnabled: get(state, 'login.hasTPCEnabled'),
    activeLanguageCode: get(state, 'language.activeLanguageCode'),
    loadingManager: get(state, 'loadingManager.loading')
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    logOut: () => dispatch(logOut()),
    logIn: () => dispatch(requestLoginSession())
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(HeaderLogin);
